/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpportunityDetailsResponse
 */
export interface OpportunityDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof OpportunityDetailsResponse
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof OpportunityDetailsResponse
     */
    externalUrl?: string;
}

/**
 * Check if a given object implements the OpportunityDetailsResponse interface.
 */
export function instanceOfOpportunityDetailsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OpportunityDetailsResponseFromJSON(json: any): OpportunityDetailsResponse {
    return OpportunityDetailsResponseFromJSONTyped(json, false);
}

export function OpportunityDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpportunityDetailsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'externalUrl': !exists(json, 'externalUrl') ? undefined : json['externalUrl'],
    };
}

export function OpportunityDetailsResponseToJSON(value?: OpportunityDetailsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'externalId': value.externalId,
        'externalUrl': value.externalUrl,
    };
}

